<template>
  <v-toolbar dense flat outlined color="lightgrey" class="pl-1 pr-1">
    <v-row dense>
      <v-col class="d-flex align-center">
        <template v-if="libelleRattachement">
          <div>
            <v-chip color="info">{{ libelleRattachement }}</v-chip>
          </div>
          <v-divider class="mr-2 ml-2" vertical />
        </template>
        <template v-if="cooperative">
          <v-chip color="primary" class="mr-1"> Coopérative </v-chip>
          <v-divider class="mr-2 ml-2" vertical />
        </template>
        <div>
          <span class="d-none d-lg-inline">Association :&nbsp;</span>
          <span class="secondary--text" data-testid="association-numero">{{ numero }}</span>
        </div>
        <v-divider class="mr-2 ml-2 d-none d-md-block" vertical />
        <div class="d-none d-md-inline">
          <span class="d-none d-lg-inline">Dénomination :&nbsp;</span>
          <span class="secondary--text" data-testid="association-denomination">{{ denomination }}</span>
        </div>
        <v-divider class="mr-2 ml-2 d-none d-md-block" vertical />
        <div class="d-none d-md-inline">
          <span class="d-none d-lg-inline">Commune :&nbsp;</span>
          <span class="secondary--text">{{ commune }}</span>
        </div>
        <template v-if="juridiction">
          <v-divider class="mr-2 ml-2 d-none d-md-block" vertical />
          <div class="d-none d-md-inline">
            <span class="d-none d-lg-inline">Juridiction :&nbsp;</span>
            <span class="secondary--text">{{ juridiction }}</span>
          </div>
        </template>
      </v-col>
      <v-col cols="auto" class="d-flex align-center">
        <span
          v-if="evenementDate"
          class="mr-2 d-none d-md-inline"
          style="font-weight: normal; font-style: italic"
        >
          Version sélectionnée:&nbsp;{{ evenementDate | datetime }}
        </span>
        <v-chip v-if="estAnnoteeRequeteRadiationOffice" color="warning" class="mr-1" label>
          Radiée d'office
        </v-chip>
        <a-association-etat-chip :etat="etat">
          <template v-if="estRectifiee">
              &nbsp;rectifiée d'office
          </template>
        </a-association-etat-chip>
      </v-col>
    </v-row>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    numero: {
      type: String,
      required: true,
    },
    juridiction: {
      type: String,
      required: false,
    },
    value: {
      type: Object,
      required: false,
    },
    rattachement: {
      type: Object,
      required: false,
    },
    premiereVersionRadieeOffice: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    demandeRattachement() {
      this.$emit("demandeRattachement");
    },
  },
  computed: {
    estRectifiee() {
      return !this.estAnnoteeRequeteRadiationOffice && this.value?.estRectifiee;
    },
    estAnnoteeRequeteRadiationOffice() {
      return !!this.value?.annotations?.radiationOffice?.date ;
    },
    etatRattachement() {
      return this.rattachement?.etat;
    },
    libelleRattachement() {
      if ("EN_COURS" === this.etatRattachement) {
        return "Rattachement en cours";
      } else if ("INVITATION_EN_COURS" === this.etatRattachement) {
        return "Invitation en cours";
      } else if ("RATTACHE" === this.etatRattachement) {
        return "Rattaché";
      }
      return null;
    },
    etat() {
      return this.value?.etatAssociation;
    },
    evenementDate() {
      return this.value?.evenementDate;
    },
    denomination() {
      return this.value?.informations?.denomination;
    },
    commune() {
      return this.value?.informations?.adresse?.commune?.libelle;
    },
    cooperative() {
      return this.value?.informations?.cooperative || false;
    },
  },
};
</script>
